import { PlacePagination } from '../../domain/model/place_pagination';
import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface FetchPlaceRepository {
    (pagination: Pagination): Promise<PlacePagination>
}

const fetchPlaceRepository = (axios: AxiosInstance): FetchPlaceRepository => async (pagination: Pagination) => {
    try {
        const response: AxiosResponse = await axios.get('/place', {
            params: pagination,
        })

        const placePagination: PlacePagination = response.data
        return placePagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchPlaceRepository